import { Reducer } from "redux";

import { get404InitialData } from "../utils";
import { DisciplineResponse } from "../models/Api/Authorization";
import { DisciplineDispatchTypes } from "../models/DispatchTypes/Authorization";
import { DisciplineActionDispatchTypes } from "../constants/Disciplines";

const initialState: DisciplineResponse = {
  loading: false,
  response: {
    totalRecords: 0,
      disciplineList: [],
      totalVisitsApproved: 0
  },
};

const DisciplineListReducer: Reducer<
  DisciplineResponse,
  DisciplineDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case DisciplineActionDispatchTypes.DISCIPLINE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DisciplineActionDispatchTypes.DISCIPLINE_SUCCESS: {
      return {
        ...state,
        response: get404InitialData(action.response, []),
        loading: false,
      };
    }
  }
  return state;
};

export default DisciplineListReducer;
